// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manager_main__1UjIW,\n.manager_mainFullWidth__1rTXT {\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 80px);\n  height: 100vh;\n  overflow: hidden;\n  background: #fafafa;\n  padding: 0; }\n\n.manager_mainFullWidth__1rTXT {\n  width: 100%; }\n", ""]);
// Exports
exports.locals = {
	"main": "manager_main__1UjIW",
	"mainFullWidth": "manager_mainFullWidth__1rTXT"
};
module.exports = exports;
